import type { CommunityOnboardingFlags } from "@circle-react/types/CommunityOnboardingFlags";
import type { CommunitySettings } from "@circle-react/types/CommunitySettings";
import type { CurrentCommunity } from "@circle-react/types/CurrentCommunity";
import type { CurrentCommunityMember } from "@circle-react/types/CurrentCommunityMember";
import type { CurrentUser } from "@circle-react/types/CurrentUser";
import type { MasqueradingEntity } from "@circle-react/types/Masquerading";
import { useEffect } from "react";
import { useQuery, useQueryClient } from "react-query";
import { punditUserKey, punditUserQueries } from "react/lib/queries/punditUser";

const FIVE_MIN_STALE_TIME = 5 * 60 * 1000;

export interface PunditUsersObject {
  cai_suf_enabled: boolean;
  circuit_breakers: Record<string, boolean>;
  current_community: CurrentCommunity;
  current_community_member: CurrentCommunityMember;
  current_community_settings: CommunitySettings;
  current_user: CurrentUser;
  display_community_switcher: boolean;
  display_welcome_banner: boolean;
  eligible_for_new_onboarding_flow: boolean;
  home_page_posts_view: boolean;
  masquerading_entity: MasqueradingEntity;
  onboarding_flags: CommunityOnboardingFlags;
  view_only_masquerading: boolean;
}

export const usePunditAPI = () => {
  const queryClient = useQueryClient();

  const query = useQuery({
    ...punditUserQueries.show(),
  });

  useEffect(() => {
    if (!query.data) return;
    queryClient.setQueryDefaults(punditUserKey.root(), {
      staleTime: FIVE_MIN_STALE_TIME,
    });
  }, [query.data, queryClient]);

  return query;
};
